import React from 'react';
import LedmoduleFeatureListItem from './LedmoduleFeatureListItem';
import { Form, Card } from 'react-bootstrap';
import { getWarningIssues, getErrorIssues } from '../../../../../utils/validationSummary';

import { connect } from 'react-redux';

class LedmoduleFeatureList extends React.Component {

    renderList() {
        return Object.values(this.props.driverFeatureWithProperties).map(ledmoduleFeature => {

            const errors = getErrorIssues(this.props.issueByProperty, ledmoduleFeature.properties);
            const warnings = getWarningIssues(this.props.issueByProperty, ledmoduleFeature.properties);

            return (
                <LedmoduleFeatureListItem
                    key={ledmoduleFeature.name}
                    ledmoduleFeature={ledmoduleFeature}
                    {...this.props}
                    errors={errors}
                    warnings={warnings}
                    isSelected={this.props.showedFeature && this.props.showedFeature.name === ledmoduleFeature.name} />
            );
        });
    }

    render() {

        if (!this.props.ledmoduleFeatures || !this.props.driverFeatureWithProperties) {
            return null;
        }

        return (
            <Card className="card-ledmodule-feature-list">
                <Card.Body className="card-body-feature-list-component">
                    <Form noValidate >
                        {this.renderList()}
                    </Form>
                </Card.Body>
            </Card>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.ledmodule.validationSummary,
        issueByProperty: state.ledmodule.issueByProperty
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LedmoduleFeatureList);